import { Link } from "react-router-dom";
import { BRAND, whatsappLink } from "@/lib/brand";
import { BrandSignature } from "./BrandSignature";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#0F0F0F] text-[#F8F6F2]" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 pt-24 pb-12 grid grid-cols-1 md:grid-cols-12 gap-14">
        <div className="md:col-span-5">
          <div className="flex items-start gap-5">
            <Link to="/" className="flex-shrink-0 inline-flex items-center justify-center w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden shadow-[0_0_35px_rgba(212,175,55,0.25)]" data-testid="footer-logo">
              <img
                src="/images/kc-logo-512.png"
                alt="THE KC INDIA — Celebrating Life with the Blessings of Mahadev"
                width="512" height="512"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </Link>
            <div>
              <div className="font-serif-display text-3xl md:text-4xl tracking-tight leading-none">
                THE <span className="italic text-[#D4AF37]">KC</span> INDIA
              </div>
              <p className="mt-3 text-[10px] uppercase tracking-[0.36em] text-[#D4AF37]">Hotels · Restaurant · Weddings · Travel · Wellness · Studios</p>
              <p className="mt-3 text-[11px] italic text-[#F8F6F2]/70 font-serif-display">Celebrating life with the blessings of Mahadev</p>
            </div>
          </div>
          <div className="mt-10">
            <BrandSignature size="md" tone="ivory" data-testid="footer-brand-signature" />
          </div>
          <p className="mt-8 font-devanagari text-base text-[#D4AF37]/90">{BRAND.taglineHi}</p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.42em] text-[#D4AF37]">Explore</div>
          <ul className="mt-6 space-y-3 text-[13px]">
            {[
              { label: "Stay", to: "/stay" },
              { label: "Char Dham", to: "/chardham" },
              { label: "Weddings", to: "/weddings" },
              { label: "Triyuginarayan", to: "/weddings/triyuginarayan" },
              { label: "About", to: "/about" },
              { label: "Gallery", to: "/gallery" },
              { label: "Journal", to: "/blog" },
              { label: "Contact", to: "/contact" },
            ].map(l => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}
                  className="text-[#F8F6F2]/75 hover:text-[#D4AF37] transition-colors uppercase tracking-[0.2em] text-[11px]"
                >{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.42em] text-[#D4AF37]">Reach the Cottage</div>
          <ul className="mt-6 space-y-4 text-[13px] text-[#F8F6F2]/85">
            <li className="flex gap-3"><MapPin size={14} className="mt-1 shrink-0 text-[#D4AF37]" /><span className="leading-relaxed">{BRAND.address}</span></li>
            <li className="flex gap-3"><Phone size={14} className="mt-1 shrink-0 text-[#D4AF37]" />
              <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-[#D4AF37] transition-colors">{BRAND.phone}</a>
            </li>
            <li className="flex gap-3"><Mail size={14} className="mt-1 shrink-0 text-[#D4AF37]" />
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="hover:text-[#D4AF37] transition-colors">{BRAND.email}</a>
            </li>
          </ul>

          <div className="mt-8 flex gap-4">
            <a href={whatsappLink()} target="_blank" rel="noreferrer" className="btn-gold" data-testid="footer-whatsapp">Message Us</a>
          </div>

          <div className="mt-8 flex gap-4 text-[#F8F6F2]/60">
            <a href="#" aria-label="Instagram" className="hover:text-[#D4AF37] transition-colors"><Instagram size={16} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-[#D4AF37] transition-colors"><Facebook size={16} /></a>
            <a href="#" aria-label="Youtube" className="hover:text-[#D4AF37] transition-colors"><Youtube size={16} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#D4AF37]/20">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between text-[10px] uppercase tracking-[0.28em] text-[#F8F6F2]/50">
          <div>© {new Date().getFullYear()} THE KC INDIA · Kedarnath Cottage</div>
          <div className="flex gap-8 mt-3 md:mt-0">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#D4AF37] transition-colors">Privacy</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-[#D4AF37] transition-colors">Terms</Link>
            <Link to="/cancellation" data-testid="footer-cancellation" className="hover:text-[#D4AF37] transition-colors">Cancellation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
